import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';
import TextField from 'components/text-field';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  input: {
    marginBottom: theme.spacing(1.5),
    '& .MuiOutlinedInput-root': {
      minHeight: 40,
      backgroundColor: theme.palette.background.paper,
      '@media (hover: none) and (pointer: coarse)': {
        minHeight: theme.spacing(5.5),
      },
    },
  },
  searchIcon: {
    color: theme.palette.text.secondary,
  },
  clearButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: 32,
      minHeight: 32,
    },
  },
}));

type PartyNameFilterProps = {
  value: string;
  onChange: (value: string) => void;
};

const PartyNameFilter: FC<PartyNameFilterProps> = ({ value, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      value={value}
      customClassName={classes.input}
      placeholder={t('parties:filter-name-placeholder')}
      inputProps={{ 'aria-label': t('parties:filter-name-label') }}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FontAwesomeIcon icon="search" className={classes.searchIcon} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              className={classes.clearButton}
              aria-label={t('common:clear')}
              onClick={() => onChange('')}
              size="large"
            >
              <FontAwesomeIcon icon="times" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};

export default PartyNameFilter;
